//import bootstrap from "bootstrap";
//import owl from "owl.carousel";
//import carousel from "./owl";
//import font from "@fortawesome/fontawesome-free"
import Menu from "./menu";
import ScrollButton from "./scrollbutton";
//import Modal from "./modal";
import slickslider from './slick';
import Busca from "./busca";
import Upload from "./upload";

document.addEventListener("DOMContentLoaded", () => {

  /* Inicia o botão de Voltar ao topo */
  const scrollbtn = new ScrollButton({ position: "left" })

  /* DEFINE OS ELEMENTOS QUE CRIAM O MENU MOBILE E SUA TRANSICAO */
  const menuFixo = document.getElementById('header-main--fixed');

  if (menuFixo) {
    const menu = new Menu();
    menu.definirMenuFixo(menuFixo, 200)
  }

  /* CAMPO DE UPLOAD ARRASTAR E SOLTAR (Orçamento) */
  const uploadContainer = document.querySelector('.fma-orcamento-form');

  if (uploadContainer) {
    new Upload(uploadContainer);
  }

});

/* Busca */
const modal = document.getElementById('busca-modal');
const btnAbrir = document.querySelectorAll('.menu-busca');
const btnFechar = document.querySelectorAll('#busca-modal__fechar, #busca-modal__fundo');

//console.log(btnFechar);

const busca = new Busca(modal, btnAbrir, btnFechar);

/* Ativar modais
 * botões com a classe definida em seletorBotao e com data-target igual ao id do modal a ser aberto
 * botão fechar dentro do modal e com a classe definida em seletorBotaoFechar
 */
//const modais = new Modal()

/* const btnAbrirMenuMobile = document.getElementById('menu-bars')
const menuMobile = document.getElementById('menu-principal--mobile')

btnAbrirMenuMobile.addEventListener('click', () => {
  console.dir(menuMobile.style.height)

  if(menuMobile.style.height == 0 || menuMobile.style.height == '0px') {
    menuMobile.style.height = `${menuMobile.scrollHeight}px`
  } else {
    menuMobile.style.height = 0
  }
}) */


/* LAZY YT */
/* const ytVideos = document.querySelectorAll('.lazy-yt');

window.addEventListener('load', () => {
  setTimeout(() => {
    ytVideos.forEach(ytVideo => {
      let src = ytVideo.getAttribute('data-src')
      ytVideo.setAttribute('src', src)
    });
  }, 1000)


})
 */





